import styled, { css } from 'styled-components'
import Select from 'react-select'
import { paragraph1CommonStyles } from '../../Typo'
import { SizeVariant } from './index'
import { up } from 'styled-breakpoints'
import { pxToRem } from '../../../utils'

const StyledSelect = styled(Select)`
  ${paragraph1CommonStyles}
  ${({ size }) =>
    size === SizeVariant.SMALL &&
    css`
      ${up('md')} {
        font-size: ${pxToRem(14)};
        line-height: ${pxToRem(20)};
      }
    `}
`

export default StyledSelect
